(function(window, document) {
	/* ----------------------------------- [START] Windows Setting */
	const html = document.documentElement;
	let ww = window.innerWidth;
	let wh = window.innerHeight;
	function getWinSet() {
		ww = window.innerWidth;
		wh = window.innerHeight;
	}
	window.addEventListener('load', getWinSet);
	window.addEventListener('resize', throttle(getWinSet, 50, 100));
	/* ----------------------------------- [END] Windows Setting */

	/* ----------------------------------- [START] 取得裝置判斷 */
	// 取得裝置判斷
	var isMobile = false;
	var isTablet = false;
	var isPhone = false;
	var deviceDetect = function () {
		// IsPhone
		isPhone = ww <= 640;

		// IsMobile
		// 防止測試時一直用開發者工具Resize出現Bug
		isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
		if (isMobile) html.classList.add('is-mobile');
		else html.classList.remove('is-mobile');

		// IsTablet
		if (navigator.userAgent.match(/Android/i)) {
			if (!navigator.userAgent.match(/Mobile/i)) {
				isTablet = true;
			}
		} else if (navigator.userAgent.match(/BlackBerry|iPad|Opera Mini|IEMobile/i)) {
			isTablet = true;
		}
	};
	deviceDetect();
	on(window, 'resize', throttle(deviceDetect, 50, 100));
	/* ----------------------------------- [END] 取得裝置判斷 */

	/* ---------------------------------------- [START] 篩選開關操作 */
	const filterPanel = document.querySelector('#pd-filter-panel');
	const $filterBody = $('.fixed-panel__body');
	const filterBtn = document.querySelector('#button-filter');
	const filterBtnStatus = filterBtn.querySelector('.status');
	const filterPanelClassOpen = 'is-open';

	const filterTextShow = filterBtn.dataset.show; // 「顯示篩選」的「顯示」文字
	const filterTextHide = filterBtn.dataset.hide; // 「隱藏篩選」的「隱藏」文字

	let filterPanelIsOpen = false; // 篩選面板是否關閉

	// 讀取 Storage 紀錄
	const filterCookieKey = 'filter-is-open';
	let filterCookieStatus = localStorage.getItem(filterCookieKey) || false;
	if (typeof filterCookieStatus === 'string') {
		filterCookieStatus = JSON.parse(filterCookieStatus);
	}

	// 如果是Open則開啟
	if (!isMobile && ww >= 1024 && filterCookieStatus) {
		filterPanelShow();
	}

	// 顯示面板
	function filterPanelShow() {
		// 關閉Scroll
		if (isMobile && ww < 1024) {
			window.docDisableScroll && docDisableScroll();

			
			setTimeout(() => {
				$filterBody.scrollTop(0);
				$filterBody.focus();
			}, 20);
		}
		filterPanelIsOpen = true;
		filterPanel.classList.add(filterPanelClassOpen);
		filterBtnStatus.innerText = filterTextHide;
		localStorage.setItem(filterCookieKey, filterPanelIsOpen);
	}

	// 隱藏面板
	function filterPanelHide() {
		// 開啟Scroll
		if (isMobile && ww < 1024) {
			window.docEnableScroll && docEnableScroll();
		}
		
		filterPanelIsOpen = false;
		filterPanel.classList.remove(filterPanelClassOpen);
		filterBtnStatus.innerText = filterTextShow;
		localStorage.setItem(filterCookieKey, filterPanelIsOpen);
	}

	// 開關篩選面板
	filterBtn.addEventListener('click', function() {
		if (!filterPanelIsOpen) {
			filterPanelShow();
		} else {
			filterPanelHide();
		}
	});

	// 展開面板內出現的關閉按鈕
	filterPanel.querySelectorAll('[data-close]').forEach((item) => {
		item.addEventListener('click', function() {
			filterPanelHide();
		});
	});
	/* ---------------------------------------- [END] 篩選開關操作 */

	/* ---------------------------------------- [START] Scroll Enabled  */
	// 因為開關會鎖 ScrollBar ，如果使用者 Resize 1024+ 就會造成無法 Scroll 問題
	const scrollBreakpoint = window.matchMedia('(min-width: 1024px)');
	const scrollBreakpointChecker = function() {
		if (scrollBreakpoint.matches) {
			// Large
			window.docEnableScroll && docEnableScroll();
		} else if (filterPanelIsOpen) {
			window.docDisableScroll && docDisableScroll();
		}
	}
	window.addEventListener('load', function() {
		scrollBreakpointChecker();
		scrollBreakpoint.addListener(scrollBreakpointChecker);
	});
	/* ---------------------------------------- [END] Scroll Enabled  */

	/* ---------------------------------------- [START] 篩選項目操作（數量計算、全部清除） */
	const filterWrapper = document.querySelector('#pd-filter');
	
	function filterInit() {
		const _this = this;
		const filterClear = document.querySelector('#pd-filter-clear');
		const filterGroup = filterWrapper.querySelectorAll('.pd-filter__group');
		const filterInput = filterWrapper.querySelectorAll('input');
		const filterHasCountPoint = filterBtn.querySelector('.point');
		const filterClassHide = 'hide';
		const filterCountArr = [];

		let hasFilter = false; // 確認是否有項目 => 控制 All 顯示隱藏

		Object.defineProperty(_this, 'hasFilter', {
			oldValue: false,
			get: function() {
				return hasFilter
			},
			set: function(value) {
				if (this.oldValue !== value) {
					hasFilter = value;
					this.oldValue = value;
					if (value) {
						filterClear.classList.remove(filterClassHide);
						filterHasCountPoint.classList.remove(filterClassHide);
					} else {
						filterClear.classList.add(filterClassHide);
						filterHasCountPoint.classList.add(filterClassHide);
					}
				}
			},
			configurable: false,
		});

		// 更改計數
		const filterCountChange = function(count, countEl, countNum) {
			countNum.innerText = count;

			if (count === 0) {
				countEl.classList.add(filterClassHide);
			} else {
				countEl.classList.remove(filterClassHide);
			}

			if (filterCountArr.every(val => val === 0)) {
				_this.hasFilter = false;
			} else {
				_this.hasFilter = true;
			}
		}

		// 以一個 Group 為單位
		filterGroup.forEach( function(group, index) {
			const inputs = group.querySelectorAll('input');
			const countEl = group.querySelector('.pd-filter__count');
			const countNum = countEl.querySelector('.num');
			let count = 0; // 計算有幾項

			// 定義在 Group 上
			group.filter = {
				inputs,
				countEl,
				countNum,
			};

			// 設定 Count 的 Get, Set 事件
			Object.defineProperty(group.filter, 'count', {
				get: function() {
					return count
				},
				set: function(value) {
					count = value;

					filterCountArr[index] = count;
					filterCountChange(count, countEl, countNum);
				},
				configurable: false,
			});

			// 以一個 Input 為單位
			inputs.forEach((input) => {
				if (input.checked) {
					group.filter.count++
				}

				input.addEventListener('change', function() {
					if (this.checked) {
						group.filter.count++
					} else {
						group.filter.count--
					}
				});
			});
		});

		// 全部清除 點擊
		filterClear.addEventListener('click', function() {
			// 延遲，移除原本是 true 的項目
			setTimeout(()=> {
				// Group 讀取
				filterGroup.forEach( function(group) {
					group.filter.count = 0;
					filterCountChange(0, group.filter.countEl, group.filter.countNum);
				});

				// 取消全部項目
				filterInput.forEach((input) => {
					input.checked = false;
				});
			}, 50);
		});

		// Count 更新(全部重新讀取)
		function update() {
			filterGroup.forEach( function(group) {
				let count = 0;
				// 以一個 Input 為單位
				group.filter.inputs.forEach((input) => {
					if (input.checked) {
						count++
					}
				});

				group.filter.count = count;
			});
		}

		window.filterUpdate = update;
	}

	window.addEventListener('load', function() {
		if (filterWrapper && filterWrapper.classList.contains('js-filter')) {
			filterInit();
		}
	});
	/* ---------------------------------------- [END] 篩選項目操作（數量計算、全部清除） */
})(window, document);
